<button [type]="buttonType" [class]="buttonClass" [disabled]="disabled || loading" (click)="loaderClicked()">
  <span>
    <ng-template #loadingSpinner>
      <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
    </ng-template>
    <ng-container *ngIf="!loading; else loadingSpinner">
      <ng-content></ng-content>
    </ng-container>
  </span>
</button>
